import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { adminCountriesAPI } from '../services/api';
import './Users.css';

const Countries = () => {
  const navigate = useNavigate();
  const [countries, setCountries] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadCountries = async () => {
    setLoading(true);
    try {
      const response = await adminCountriesAPI.getAll();
      setCountries(response.data?.countries || []);
    } catch (error) {
      toast.error('Error loading countries: ' + (error.response?.data?.message || error.message));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadCountries();
  }, []);

  if (loading && countries.length === 0) return <div className="loading">Loading countries...</div>;

  return (
    <div className="users-container">
      <p style={{ marginBottom: 16, color: '#555', fontSize: 14 }}>
        Toggle <strong>Allowed at checkout</strong> to control which countries customers may choose when saving addresses.
        All ISO countries are listed; shipping rates still reference countries independently.
      </p>

      <div className="table-container">
        <table>
          <thead>
            <tr>
              <th>Code</th>
              <th>Name</th>
              <th>Checkout</th>
              <th>Sort</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {countries.length === 0 ? (
              <tr>
                <td colSpan="5" style={{ textAlign: 'center', padding: 20 }}>
                  No countries found
                </td>
              </tr>
            ) : (
              countries.map((c) => (
                <tr key={c.id}>
                  <td>{c.code}</td>
                  <td>{c.name}</td>
                  <td>{c.is_allowed ? 'Yes' : 'No'}</td>
                  <td>{c.sort_order}</td>
                  <td className="actions">
                    <button type="button" className="btn btn-primary" onClick={() => navigate(`/countries/${c.id}/edit`)}>
                      Edit
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Countries;
